import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import spreadsReducer from './spreadsSlice';
import yieldsReducer from './yieldsSlice';
import tickersReducer from './tickersSlice';
import listsReducer from './listsSlice';
import tickerTapeReducer from './tickerTapeSlice';
import alertsReducer from './alertsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    spreads: spreadsReducer,
    yields: yieldsReducer,
    tickers: tickersReducer,
    lists: listsReducer,
    tickerTape: tickerTapeReducer,
    alerts: alertsReducer,
  },
});